/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import confluentLogo from '@/assets/MongoDB_SlateBlue.png'

const handleStyleLeft = { left: -2, top: 44 }

function MongoDBNode({ data, isConnectable }) {
  return (
    <div className="custom-node-plc plc-limits">
      <Handle type="target" position={Position.Left} style={handleStyleLeft} />

      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={confluentLogo} alt="Conlfuent Logo" className="custom-node-partner-logo" />
          </div>
          <div className="text-center">
            <b>MongoDB</b>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MongoDBNode
